export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/home/runner/work/cuhk-osce-platform/cuhk-osce-platform/frontend/src/pages/index.vue'),
    /* no children */
    meta: {
      "layout": false
    }
  },
  {
    path: '/admin',
    /* internal name: '/admin' */
    /* no component */
    children: [
      {
        path: '',
        name: '/admin/',
        component: () => import('/home/runner/work/cuhk-osce-platform/cuhk-osce-platform/frontend/src/pages/admin/index.vue'),
        /* no children */
        meta: {
          "hideFooter": true
        }
      }
    ],
  },
  {
    path: '/analytics',
    name: '/analytics',
    component: () => import('/home/runner/work/cuhk-osce-platform/cuhk-osce-platform/frontend/src/pages/analytics.vue'),
    /* no children */
  },
  {
    path: '/auth',
    /* internal name: '/auth' */
    /* no component */
    children: [
      {
        path: '',
        name: '/auth/',
        component: () => import('/home/runner/work/cuhk-osce-platform/cuhk-osce-platform/frontend/src/pages/auth/index.vue'),
        /* no children */
      },
      {
        path: 'change-password',
        name: '/auth/change-password',
        component: () => import('/home/runner/work/cuhk-osce-platform/cuhk-osce-platform/frontend/src/pages/auth/change-password.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/case',
    /* internal name: '/case' */
    /* no component */
    children: [
      {
        path: ':caseId',
        name: '/case/[caseId]',
        component: () => import('/home/runner/work/cuhk-osce-platform/cuhk-osce-platform/frontend/src/pages/case/[caseId].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/case-setup',
    /* internal name: '/case-setup' */
    /* no component */
    children: [
      {
        path: ':caseId',
        name: '/case-setup/[caseId]',
        component: () => import('/home/runner/work/cuhk-osce-platform/cuhk-osce-platform/frontend/src/pages/case-setup/[caseId].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/chat',
    /* internal name: '/chat' */
    /* no component */
    children: [
      {
        path: ':caseId',
        name: '/chat/[caseId]',
        component: () => import('/home/runner/work/cuhk-osce-platform/cuhk-osce-platform/frontend/src/pages/chat/[caseId].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/contact',
    name: '/contact',
    component: () => import('/home/runner/work/cuhk-osce-platform/cuhk-osce-platform/frontend/src/pages/contact.vue'),
    /* no children */
  },
  {
    path: '/eula',
    name: '/eula',
    component: () => import('/home/runner/work/cuhk-osce-platform/cuhk-osce-platform/frontend/src/pages/eula.vue'),
    /* no children */
  },
  {
    path: '/login',
    name: '/login',
    component: () => import('/home/runner/work/cuhk-osce-platform/cuhk-osce-platform/frontend/src/pages/login.vue'),
    /* no children */
    meta: {
      "layout": false
    }
  },
  {
    path: '/practice',
    /* internal name: '/practice' */
    /* no component */
    children: [
      {
        path: '',
        name: '/practice/',
        component: () => import('/home/runner/work/cuhk-osce-platform/cuhk-osce-platform/frontend/src/pages/practice/index.vue'),
        /* no children */
      },
      {
        path: ':mode',
        /* internal name: '/practice/[mode]' */
        /* no component */
        children: [
          {
            path: '',
            name: '/practice/[mode]/',
            component: () => import('/home/runner/work/cuhk-osce-platform/cuhk-osce-platform/frontend/src/pages/practice/[mode]/index.vue'),
            /* no children */
          },
          {
            path: ':category',
            name: '/practice/[mode]/[category]',
            component: () => import('/home/runner/work/cuhk-osce-platform/cuhk-osce-platform/frontend/src/pages/practice/[mode]/[category].vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/progress',
    /* internal name: '/progress' */
    /* no component */
    children: [
      {
        path: '',
        name: '/progress/',
        component: () => import('/home/runner/work/cuhk-osce-platform/cuhk-osce-platform/frontend/src/pages/progress/index.vue'),
        /* no children */
      },
      {
        path: ':sessionId',
        name: '/progress/[sessionId]',
        component: () => import('/home/runner/work/cuhk-osce-platform/cuhk-osce-platform/frontend/src/pages/progress/[sessionId].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/register',
    name: '/register',
    component: () => import('/home/runner/work/cuhk-osce-platform/cuhk-osce-platform/frontend/src/pages/register.vue'),
    /* no children */
    meta: {
      "layout": false
    }
  },
  {
    path: '/resources',
    name: '/resources',
    component: () => import('/home/runner/work/cuhk-osce-platform/cuhk-osce-platform/frontend/src/pages/resources.vue'),
    /* no children */
  },
  {
    path: '/settings',
    name: '/settings',
    component: () => import('/home/runner/work/cuhk-osce-platform/cuhk-osce-platform/frontend/src/pages/settings.vue'),
    /* no children */
  },
  {
    path: '/u',
    /* internal name: '/u' */
    /* no component */
    children: [
      {
        path: ':id',
        name: '/u/[id]',
        component: () => import('/home/runner/work/cuhk-osce-platform/cuhk-osce-platform/frontend/src/pages/u/[id].vue'),
        /* no children */
      }
    ],
  }
]

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

